import { EnergyBar } from '../../../shared/components/EnergyBar'
import { CrypticStage } from './CrypticStage'
import { ConfirmedSegment } from '../../../shared/labs/transcript'

// The active cryptic play screen: the clue stage with the energy bar between clue and
// transcript, and Commit/Pass underneath. Mirrors the 24-game PuzzleView — the spoken
// transcript is the think-aloud; the typed answer box appears later (after commit).
export const CrypticView = ({
  clue,
  energy,
  speaking,
  dimmed,
  confirmedSegments,
  interimText,
  progressLabel,
  showNudge,
  onCommit,
  onPass,
}: {
  clue: string
  energy: number
  speaking: boolean
  dimmed: boolean
  confirmedSegments: ConfirmedSegment[]
  interimText: string
  progressLabel?: string
  showNudge?: boolean
  onCommit: () => void
  onPass: () => void
}) => (
  <CrypticStage
    clue={clue}
    dimmed={dimmed}
    confirmedSegments={confirmedSegments}
    interimText={interimText}
    progressLabel={progressLabel}
    showNudge={showNudge}
    middle={<EnergyBar energy={energy} speaking={speaking} dimmed={dimmed} />}
  >
    <button
      type="button"
      onClick={onCommit}
      className="w-full rounded-lg bg-[#398874] py-3 text-white font-semibold leading-tight"
    >
      Commit answer
      <br />
      <span className="text-sm font-normal opacity-90">(or just say “commit”)</span>
    </button>
    <button
      type="button"
      onClick={onPass}
      className="mt-2 w-full rounded-lg border border-gray-200 py-2 text-sm font-medium text-gray-400 hover:bg-gray-50"
    >
      Pass
    </button>
    <p className="mt-2 text-center text-xs text-gray-400">You decide when to commit — up to 3 minutes per clue.</p>
  </CrypticStage>
)
